import { SVGProps } from 'react';

export default function FireHydrantIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" {...props}>
      <circle cx="15" cy="15" r="12" fill="#3F454D" />
      <path
        d="M14.9316 7.45539C14.5956 7.45539 14.3076 7.66145 14.187 7.95414C12.6983 8.08144 11.5448 8.97609 11.5448 10.0608V10.7715H18.3184V10.0608C18.3184 8.9761 17.165 8.08147 15.6762 7.95415C15.5558 7.66145 15.2678 7.45539 14.9316 7.45539Z"
        fill="white"
      />
      <path
        d="M10.7592 11.8243C10.7592 11.5751 10.9612 11.3731 11.2104 11.3731H18.6527C18.9019 11.3731 19.1038 11.5751 19.1038 11.8243V12.0769C19.1038 12.3261 18.9019 12.5281 18.6527 12.5281H11.2104C10.9612 12.5281 10.7592 12.3261 10.7592 12.0769V11.8243Z"
        fill="white"
      />
      <path
        d="M10.7592 21.3897C10.7592 21.1405 10.9612 20.9385 11.2104 20.9385H18.6527C18.9019 20.9385 19.1038 21.1405 19.1038 21.3897V22.0934C19.1038 22.3426 18.9019 22.5446 18.6527 22.5446H11.2104C10.9612 22.5446 10.7592 22.3426 10.7592 22.0934V21.3897Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3184 14.7955V13.1297H11.5448V14.7955H10.7188C10.2205 14.7955 9.81649 15.1995 9.81649 15.6979V15.9816C9.51438 16.0975 9.2998 16.3904 9.2998 16.7333C9.2998 17.0763 9.51438 17.3691 9.81649 17.4851V17.7687C9.81649 18.2671 10.2205 18.6711 10.7188 18.6711H11.5448V20.3369H18.3184V18.6711H19.1442C19.6425 18.6711 20.0466 18.2671 20.0466 17.7687V17.5242C20.4193 17.4537 20.7012 17.1264 20.7012 16.7333C20.7012 16.3402 20.4193 16.0129 20.0466 15.9425V15.6979C20.0466 15.1995 19.6425 14.7955 19.1442 14.7955H18.3184ZM12.9937 16.7333C12.9937 15.6631 13.8612 14.7955 14.9315 14.7955C16.0017 14.7955 16.8692 15.6631 16.8692 16.7333C16.8692 17.8035 16.0017 18.6711 14.9315 18.6711C13.8612 18.6711 12.9937 17.8035 12.9937 16.7333Z"
        fill="white"
      />
      <path
        d="M16.2079 16.7333C16.2079 17.4386 15.6363 18.0103 14.931 18.0103C14.2259 18.0103 13.6541 17.4386 13.6541 16.7333C13.6541 16.0281 14.2259 15.4564 14.931 15.4564C15.6363 15.4564 16.2079 16.0281 16.2079 16.7333Z"
        fill="white"
      />
    </svg>
  );
}
